import { render } from "./Order.vue?vue&type=template&id=2e50c57a"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=2e50c57a&lang=css"
script.render = render

export default script